"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstLoginView = void 0;
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var avatars_1 = require("components/Avatar/avatars");
var NavigationComponents_1 = require("./NavigationComponents");
var dispatchers_1 = require("./utils/dispatchers");
var utils_1 = require("./utils/utils");
require("./style.scss");
var FirstLoginView = function (props) {
    var _a = (0, react_redux_1.useSelector)(function (state) { return ({
        firstLogin: state.firstLogin,
        auth: state.auth,
        currentUser: state.auth.current.user,
        userLanguage: state.firstLogin.step1.user.language
    }); }), firstLogin = _a.firstLogin, auth = _a.auth, currentUser = _a.currentUser, userLanguage = _a.userLanguage;
    var states = (0, utils_1.setStateProps)(firstLogin, auth, currentUser, userLanguage);
    var dispatchers = (0, dispatchers_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var reMappedProps = (0, react_1.useMemo)(function () { return (__assign(__assign(__assign({}, props), dispatchers), states)); }, [props, dispatchers, states]);
    (0, react_1.useEffect)(function () {
        reMappedProps.fetchRegions();
        if (reMappedProps.auth.current.status === 'STANDBY') {
            reMappedProps.fetchUser();
        }
    }, []);
    (0, react_1.useEffect)(function () {
        var user = reMappedProps.auth.current.user.toNullable();
        if (reMappedProps.auth.current.status === 'FETCHED' && user) {
            reMappedProps.shouldRedirectToTerms();
            var userStatus = [
                'FIRST_TIME',
                'TERMS_NOT_ACCEPTED',
                'MISSING_INFORMATION'
            ].includes(user.status);
            userStatus
                ? (0, utils_1.setInitData)(user, reMappedProps)
                : reMappedProps.returnToApp();
        }
    }, [reMappedProps.auth.current.status]);
    return (React.createElement("div", { className: 'first-login-view' },
        reMappedProps.auth.current.status === 'FETCHED' && (React.createElement("div", { className: 'content' },
            React.createElement("div", { className: "welcome-message" },
                React.createElement("h3", null, (0, translation_1.getLocalization)('firstTimeLogin/header/welcome')),
                React.createElement("p", null, (0, translation_1.getLocalization)('firstTimeLogin/header/description'))),
            React.createElement(sok_ui_1.StepBar, { currentStep: reMappedProps.firstLogin.page, steps: [
                    (0, translation_1.getLocalization)('firstTimeLogin/step1/profileInformation'),
                    (0, translation_1.getLocalization)('firstTimeLogin/step2/selectYourAvatar'),
                    (0, translation_1.getLocalization)('firstTimeLogin/step3/TermsAndConditions')
                ] }),
            (0, utils_1.getStep)(reMappedProps)[reMappedProps.firstLogin.page],
            React.createElement("div", { className: 'navigation-buttons' },
                React.createElement(NavigationComponents_1.NavigationComponents, __assign({}, reMappedProps))))),
        reMappedProps.auth.current.status === 'FETCHING' && (React.createElement("div", { className: 'first-login-view-loading' },
            React.createElement(sok_ui_1.LoadingSpinner, null),
            (0, translation_1.getLocalization)('firstTimeLogin/loadingUserInfo'))),
        reMappedProps.auth.current.status === 'FAILED' && (React.createElement("div", { className: 'first-login-view-failed' },
            React.createElement("div", null,
                React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_19') })),
            React.createElement("h3", null, (0, translation_1.getLocalization)('firstTimeLogin/unableToFetchUser')),
            React.createElement("span", null,
                (0, translation_1.getLocalization)('userFront/loadingView/pleaseContact'),
                ' ',
                React.createElement("a", { href: 'mailto:helpdesk@sokopro.fi' }, (0, translation_1.getLocalization)('userFront/loadingView/contactHelpdesk')))))));
};
exports.FirstLoginView = FirstLoginView;
exports.default = (0, react_1.memo)(exports.FirstLoginView);
